import loadable from "@loadable/component";

export const OpsSettingsList = loadable(() => import("./list"));
export const UserDetail = loadable(() => import("./user-detail"));
